import React, { useState } from "react";
import AllStoresCanvas from "./AllStoreCanvas";

const AllStoreBottomStickyMenu = ({ activeStores }) => {
  const [showCanvas, setShowCanvas] = useState(false);

  return (
    <>
      <div className="redeem-at-x-more-stores">
        <div className="content">
          <img src="../assets/icons/shop.svg" alt="shop icon" />
          <p>
            Earn and Redeem
            <br />
            at {activeStores?.length} more stores
          </p>
          <button onClick={() => setShowCanvas(!showCanvas)}>
            Show{" "}
            <img src="../assets/icons/right-dark-arrow.svg" alt="arrow icon" />
          </button>
        </div>
      </div>
      <AllStoresCanvas
        isOpen={showCanvas}
        activeStores={activeStores}
        toggleCanvas={() => setShowCanvas(!showCanvas)}
      />
    </>
  );
};

export default AllStoreBottomStickyMenu;
